import { useNavigate } from 'react-router';

export const useUpdateQueryParams = () => {
  const navigate = useNavigate();
  return (
    queryParams: URLSearchParams,
    navigateParams: Record<string, unknown> = { replace: false },
  ): void => {
    navigate(
      {
        pathname: window.location.pathname,
        search: queryParams.toString(),
      },
      navigateParams,
    );
  };
};
